/**
 * Handles radios and checkboxes change event to toggle a class to a given element
 * @module productOptView
 */

import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import mergeOptions from '../lib/merge-options';

export const PLUGIN_NAME = 'productOptView';
export const DEFAULTS = {
  triggerElement: 'product__image-alt-trigger',
  altLoadedClass: 'product__image-alt-view--loaded',
  altImage: 'product__image-alt-view'
};

const getImage = ($el, { altImage }) => {
  const $image = $el.find(`.${altImage}`);
  const imageUrl = $image.data('lazy-src');
  const imageSet = $image.data('lazy-srcset');
  $image
    .removeAttr('data-lazy-src').removeAttr('data-lazy-srcset')
    .attr('src', imageUrl).attr('srcset', imageSet);
}


/**
 * Applies any sort of event handlers for the checkboxes or radios.
 * @param  {jQuery} $el - checkbox / radio
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
const setEventListeners = ($el, options) => {
  const { triggerElement, altLoadedClass } = options;
  $el.on('mouseenter.showAltImage', `.${triggerElement}`, function(e) {
    if($(this).hasClass(altLoadedClass)) return;
    getImage($(e.currentTarget), options);
    $(this).addClass(altLoadedClass);
  });
};

/**
 * Initializes productOptView.
 * @param {HTMLElement} el - button /element that triggers productOptView
 * @param {Object} options - Options used for wiring up the productOptView
 * @param {Object} deregister - Performs a deregisteration on the plugin
 * @see DEFAULTS
 */
export default function productOptView(el, options = {}) {
  const $el = $(el);
  const opts = mergeOptions(DEFAULTS, options, $el);
  setEventListeners($el, opts);
}

registerJQueryPlugin(PLUGIN_NAME, productOptView);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/product-opt-view.js